/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import useStyles from "./styles";
import moment from "moment";
import Loading from "./components/Loading";
import ItemInfo from "./components/ItemInfo";
import ButtonConfirm from "./components/ButtonConfirm";

import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { Images } from "config/images";
import { useHistory } from "react-router-dom";
import {
	getImages,
	getTitle,
	getSubTitle
} from "./components/configVerifyDevice";
import { approvedStatusDeviceAction } from "store/actions/LoginPageAction";
import { REDIRECT_CHANGE_PASSWORD } from "config/constant";
import { getIsSkip } from "utils/utils";

const VerifyDevicePage = props => {
	const { infoShop, changeStatusApproved } = props;
	const classes = useStyles();
	const history = useHistory();
	const getQueryParam = paramName =>
		new URLSearchParams(history.location.search).get(paramName);

	const message = getQueryParam("message");
	const modelName = getQueryParam("modelName");
	const typeDevice = getQueryParam("typeDevice");
	const uid = getQueryParam("uid");
	const type = typeDevice || infoShop?.statusRegisterDevice;

	const handleWaitingApprove = () => {
		if (typeof window !== undefined) {
			window?.ReactNativeWebView?.postMessage(
				`SHARE, Đường dẫn duyệt yêu cầu đăng nhập đến ứng dụng của khách hàng CRM \r\n ${infoShop?.urlUserRegisterDevice}`
			);
		}
	};

	const isSkip = getIsSkip();

	const handleNewApproved = () => {
		const onSuccess = () => {
			const passwordType = infoShop?.passwordType;
			if (REDIRECT_CHANGE_PASSWORD.includes(passwordType)) {
				const redirect = passwordType === "ABOUT_TO_EXPIRE" && !isSkip;
				redirect && localStorage.setItem("isSkipChangePassword", true);
				history.push("/change_password");
			} else {
				history.push("/home");
			}
		};
		const dataSubmit = { data: { uid }, onSuccess: onSuccess };
		changeStatusApproved(dataSubmit);
	};

	const handleLogout = () => {
		localStorage.clear();
		if (typeof window !== undefined) {
			window?.ReactNativeWebView?.postMessage("LOGOUT");
		}
		// window.location.replace("/"); //TODO: delete
	};

	const onConfirm = () => {
		switch (type) {
			case "WAITING_APPROVE":
				handleWaitingApprove();
				break;
			case "NEW_APPROVED":
				handleNewApproved();
				break;
			case "REJECTED":
				handleLogout();
				break;
			case "LOCKED":
				handleLogout();
				break;
			default:
				break;
		}
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.rootBg }}>
				<img
					src={
						type === "LOCKED"
							? Images.bgDevice
							: Images.bgDeviceActive
					}
					alt="bgDeviceActive"
				/>
			</Grid>
			<Grid classes={{ root: classes.rootCity }}>
				<img
					src={type === "LOCKED" ? Images.city : Images.cityActive}
					alt="city"
				/>
			</Grid>
			<Grid classes={{ root: classes.bodyPage }}>
				<Grid style={{ textAlign: "center" }}>
					<Grid style={{ textAlign: "center", paddingBottom: 20 }}>
						<img
							src={Images[`${getImages(type)}`]}
							alt={`${getImages(type)}`}
							style={{ width: "100%", maxWidth: 270 }}
						/>
					</Grid>
					<Grid classes={{ root: classes.title }}>
						{getTitle(type)}
					</Grid>
					<Grid classes={{ root: classes.subTitle }}>
						{message ? message : getSubTitle(type)}
					</Grid>
				</Grid>
				{type === "WAITING_APPROVE" && (
					<React.Fragment>
						<Loading />
						<Grid
							style={{
								display: "flex",
								justifyContent: "center",
								padding: 20
							}}
						>
							<Grid classes={{ root: classes.driver }} />
						</Grid>
						<Grid classes={{ root: classes.rootBody }}>
							<ItemInfo
								title="Người dùng"
								value={infoShop?.shopName || ""}
							/>
							<ItemInfo
								title="Thiết bị"
								value={modelName || "-"}
							/>
							<ItemInfo title="IMEI" value={uid || "-"} />
							<ItemInfo
								title="Thời gian"
								value={moment().format("hh:mm - DD/MM/YYYY")}
							/>
						</Grid>
					</React.Fragment>
				)}
			</Grid>
			<ButtonConfirm type={type} onConfirm={onConfirm} />
		</Grid>
	);
};

const mapStateToProps = state => {
	return {
		infoShop: state.homePageReducer.infoShop
	};
};

const mapDispatchToProps = dispatch => {
	return {
		changeStatusApproved: data => {
			dispatch(approvedStatusDeviceAction(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyDevicePage);
